import { formatDateFromDB } from '../../../../../utils/FormatDate';
import MuiGrid from '../../../UI/MuiGrid/MuiGrid';

const GridProviderUsluge = ({ data = [], isLoading }) => {
  const columns = [
    // { field: 'zaposleni', headerName: 'Zaposleni', width: 200 },
    // { field: 'nazivUsluge', headerName: 'Naziv', width: 200 },
    // { field: 'kolicina', headerName: 'Sati rada', width: 150 },
    // { field: 'cena', headerName: 'Cena', width: 200 },
    { field: 'zaposleni', headerName: 'Zaposleni', width: 200 },
    { field: 'nazivUsluge', headerName: 'Naziv usluge', width: 200 },
    { field: 'jm', headerName: 'Jedinica mere', width: 120 },
    { field: 'kolicina', headerName: 'Količina', width: 80 },
    { field: 'brutoCenaZaposlenog', headerName: 'Bruto cena', width: 80 },
    { field: 'cena', headerName: 'Cena', width: 80 },
    {
      field: 'datum',
      headerName: 'Datum',

      width: 150,
      renderCell: (e) => formatDateFromDB(e.row.datum),
    },
    { field: 'napomena', headerName: 'Napomena', width: 300 },
  ];

  return (
    <div style={{ height: '85vh', width: '99%' }}>
      <MuiGrid data={data} columns={columns} loading={isLoading} />
    </div>
  );
};

export default GridProviderUsluge;
